import {
  Location,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import { useGetLegacyReport } from "../api/LegacyReportsApi";
import { useEffect } from "react";
import LegacyReportSummaryHeader from "./LegacyReportSummaryHeader";
import LegacyReportSummaryContent from "./LegacyReportSummaryContent";
import LoadingSpinner from "../shared-components/LoadingSpinner";
import { ChevronLeftIcon } from "@heroicons/react/24/outline";

function LegacyReportSummary() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const location: Location = useLocation();
  const locationState = location.state as {
    fromCompanyUUID?: string;
  };

  const {
    data: report,
    isLoading,
    error,
    mutate,
  } = useGetLegacyReport(id as string);

  useEffect(() => {
    if (id) mutate(id);
  }, [id, mutate]);

  if (isLoading) return <LoadingSpinner />;

  if (error) {
    throw new Error(`Error loading report with ID: ${id ?? "N/A"}`);
  }

  if (!report) return null;

  return (
    <>
      <div
        className="cursor-pointer text-bold text-black-500 flex items-center"
        onClick={() =>
          navigate("/reports/legacy", {
            state: { fromCompanyUUID: locationState?.fromCompanyUUID },
          })
        }
      >
        <ChevronLeftIcon className="h-4 w-4 mr-1" />
        <span className="text-sm">Back to List</span>
      </div>
      <div className="font-extrabold text-2xl my-4">Legacy Report Summary</div>
      <div className="mx-auto">
        <div className="w-full h-16 bg-[#126798]" />
        <LegacyReportSummaryHeader report={report} />
        <div className="w-full h-6 bg-[#126798]" />
        <LegacyReportSummaryContent report={report} />
      </div>
    </>
  );
}

export default LegacyReportSummary;
